import { useState } from 'react';
import styles from './Overlay.module.css';
import { IconCloseBold } from '../../assets/icons';

const Overlay = ({
    children,
    className,
    style,
    headerTitle,
    onClose,
    persist = false
}) => {
    const [show, setShow] = useState(true);
    const handleClose = (e) => {
        if (persist) return;
        e.preventDefault();
        setShow(false);
        onClose();
    }

    return (
        <div
            className={`${styles.overlay} ${show ? 'show' : ''} ${className}`}
            style={style}
        >
            <div className={styles.overlayInner}>
                <div className={styles.overlayHeader}>
                    {headerTitle &&
                        <h2 className={styles.overlayHeaderTitle}>{headerTitle}</h2>
                    }

                    {!persist && (
                        <button
                            className={styles.overlayCloseBtn}
                            onClick={(e) => handleClose(e)}
                        >
                            <IconCloseBold />
                        </button>
                    )}
                </div>

                <div className={styles.overlayContent}>
                    {children}
                </div>
            </div>
        </div>
    );
}

export default Overlay;
